import { createSlice } from "@reduxjs/toolkit";

export interface BreefInviteTrackingSummary {
  breefId: string;
  breefName: string;
  tenantId: string;
  tenantName: string;
  tenantEmail: string;
  tenantPhone: string;
  totalInvites: number;
  sentCount: number;
  failedCount: number;
  pendingCount: number;
}

export interface BreefInviteUserDetail {
  inviteId: string;
  inviteUserId: string;
  userName: string;
  destination?: string;
  inviteType: string;
  // Absent (not just falsy) means this invite predates delivery tracking and was never tracked -
  // distinct from "PENDING", which means it IS tracked and currently in flight. Don't default
  // this to "PENDING" when rendering; treat undefined as "no tracking data" instead.
  sendStatus?: "PENDING" | "SENT" | "FAILED";
  sendError?: string;
  attempts?: number;
  lastAttemptAt?: string;
  sentAt?: string;
}

interface PaginatedResponse<T> {
  results: T[];
  page: number;
  limit: number;
  totalPages: number;
  totalResults: number;
}

const emptyTracking: PaginatedResponse<BreefInviteTrackingSummary> = {
  results: [],
  page: 0,
  limit: 0,
  totalPages: 0,
  totalResults: 0,
};

const emptyUserDetails: PaginatedResponse<BreefInviteUserDetail> = {
  results: [],
  page: 0,
  limit: 0,
  totalPages: 0,
  totalResults: 0,
};

const InitialState = {
  trackingData: emptyTracking,
  userDetailsData: emptyUserDetails,
};

export const BreefInviteSlice = createSlice({
  initialState: InitialState,
  name: "breefInvites",
  reducers: {
    setBreefInviteTrackingData: (state, action) => {
      state.trackingData = action.payload;
    },
    setBreefInviteUserDetailsData: (state, action) => {
      state.userDetailsData = action.payload;
    },
  },
});

export const { setBreefInviteTrackingData, setBreefInviteUserDetailsData } = BreefInviteSlice.actions;
export default BreefInviteSlice.reducer;
